import applicationTitles from "./applicationTitles";

const applicationTitleService = [
    {
        matcher: 'applicationTitles',
        reply: config => {
            return [200, applicationTitles];
        }
    }
]

export default applicationTitleService;